// extracted by mini-css-extract-plugin
export default {"container":"ViewFinder_container__4AdUe","viewFinder":"ViewFinder_viewFinder__vx6EL","overlay":"ViewFinder_overlay__rmzxy","button":"ViewFinder_button__Tg52B"};